// Map projection scales
export const MAP_SCALES = {
  mobilePortrait: 1950,
  mobileLandscape: 1950,
  tabletPortrait: 1950,
  tabletLandscape: 1950,
  desktop: 1950
} as const;

// Map center coordinates for New Zealand
export const NZ_MAP_CENTER: [number, number] = [173.5, -41.3];

// Map center coordinates for United Kingdom
export const UK_MAP_CENTER: [number, number] = [-2.0, 54.5];

// Map projection scales for UK
export const UK_MAP_SCALES = {
  mobilePortrait: 2800,
  mobileLandscape: 2800,
  tabletPortrait: 2800,
  tabletLandscape: 2800,
  desktop: 2800
} as const;

// Map zoom settings
export const MAP_ZOOM = {
  level: 1,
  center: [173.5, -41.3] as [number, number]
} as const;

// Airport marker dot position offsets
export const AIRPORT_DOT_OFFSETS = {
  NZOH: -5,
  NZPM: 3,
  DEFAULT: 0
} as const;

// Airport label positioning
export const AIRPORT_LABEL_POSITIONS: Record<string, {
  textAnchor: 'end' | 'middle' | 'start';
  x: number;
  y: number;
}> = {
  // Special positioning for specific airports
  NZOH: {
    textAnchor: 'end',
    x: -18,
    y: 4
  },
  NZPM: {
    textAnchor: 'middle',
    x: 12,
    y: 20
  },
  NZRO: {
    textAnchor: 'middle',
    x: 20,
    y: 15
  },
  // Airports positioned above their markers
  NZKK: {
    textAnchor: 'middle',
    x: 0,
    y: -12
  },
  NZTG: {
    textAnchor: 'middle',
    x: 0,
    y: -12
  },
  NZNS: {
    textAnchor: 'middle',
    x: 0,
    y: -12
  },
  // Default positioning
  DEFAULT: {
    textAnchor: 'middle',
    x: 0,
    y: 20
  }
};

// Pulse animation constants for severe fog
export const PULSE_ANIMATION = {
  radiusFrom: 8,
  radiusTo: 20,
  duration: '2s',
  opacityFrom: 0.6,
  opacityTo: 0,
  initialOpacity: 0.3
} as const;

// Airport marker sizing
export const MARKER_SIZES = {
  radius: 8,
  strokeWidthSelected: 2,
  strokeWidthNormal: 1.5,
  dividerStrokeWidth: 1,
  dividerOpacity: 0.7
} as const;

// SVG text styling for airport labels
export const AIRPORT_LABEL_STYLE = {
  fontFamily: 'Roboto',
  fontSize: '10px',
  fontWeight: '600',
  fill: '#fff',
  stroke: '#000',
  strokeWidth: '2.5px',
  paintOrder: 'stroke' as const,
  letterSpacing: '0.5px'
} as const;

// Geography (map outline) styling
export const GEOGRAPHY_STYLE = {
  fill: '#333',
  stroke: '#FFF',
  strokeWidth: 0.5
} as const;

// Map component styles
export const MAP_COMPONENT_STYLES = {
  composableMap: {
    width: '100%',
    height: '100%'
  },
  markerGroup: {
    cursor: 'pointer'
  },
  geographyInteraction: {
    default: { outline: 'none' },
    hover: { outline: 'none', fill: '#333' },
    pressed: { outline: 'none' }
  }
} as const;